var $924ec5973b9d52a8$exports = {};
$924ec5973b9d52a8$exports = {
    "collapse": `\xd6sszecsuk\xe1s`,
    "expand": `Kibont\xe1s`
};


export {$924ec5973b9d52a8$exports as default};
//# sourceMappingURL=hu-HU.module.js.map
